import { Form, Drawer, Button, Space } from "antd";
import PreconditionForm from "../ui/PreconditionForm";
import Task from "../ui/Task";
import Email from "./Email";
import Project from "./Project";
import { convertCamelCaseToNormal } from "../../shared/lib/convert-camel-to-normal";

const ModalForm = ({
  open,
  onCancel,
  formType,
  workflowForm,
  activeStepIndex,
  stepsCount,
  poolMembers,
  poolList,
}) => {
  const stepData = workflowForm.getFieldValue("steps");
  const [form] = Form.useForm();
  const onOk = () => {
    form.submit();
  };

  return (
    <Drawer
      title={`Add ${convertCamelCaseToNormal(formType)}`}
      open={open}
      onClose={onCancel}
      width={"30%"}
      placement="right"
      extra={[
        <Space>
          <Button key="cancel" onClick={onCancel}>
            Cancel
          </Button>
          <Button key="submit" type="primary" onClick={onOk}>
            Submit
          </Button>
        </Space>,
      ]}
    >
      {formType === "precondition" && (
        <PreconditionForm
          form={form}
          stepData={stepData[activeStepIndex]}
          activeStepIndex={activeStepIndex}
          stepsCount={stepsCount}
        />
      )}
      {formType === "project" && (
        <Project
          form={form}
          stepData={stepData[activeStepIndex]}
          activeStepIndex={activeStepIndex}
          stepsCount={stepsCount}
          poolList={poolList}
        />
      )}
      {formType === "task" && (
        <Task
          form={form}
          stepData={stepData[activeStepIndex]}
          activeStepIndex={activeStepIndex}
          poolMembers={poolMembers}
        />
      )}
      {formType === "email" && <Email />}
    </Drawer>
  );
};

export default ModalForm;
